export default __webpack_public_path__ + "static/media/aleksandar.cf2e21e3.jpg";